import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { space } from '@synoptic/ui-kit/tokens.ts';
import { style } from '@vanilla-extract/css';

export const medalsContainer = style({
  display: 'flex',
  flexWrap: 'wrap',
  gap: space.s16,
  margin: `${space.s16}px 0`,
});

export const tournamentsEmpty = style([
  {
    display: 'flex',
    flexDirection: 'column',
    gap: space.s16,
    alignItems: 'start',
  },
  responsiveStyle({
    mobile: {
      marginTop: space.s16,
    },
    tablet: {
      marginTop: space.s28,
    },
  }),
]);
